import AppConfig from '@/shared/config';

AppConfig.lang = 'ja';
AppConfig.baseApi = 'https://purchase-history.link/api/v1';
AppConfig.authApi = 'https://purchase-history.link/auth';

export default AppConfig;
